import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return value;

    // Regular expression to detect URLs
    const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;

    // Replace URLs with anchor tags
    const formattedText = value.replace(urlRegex, (url) => {
      let hyperlink = url;
      if (!hyperlink.startsWith('http')) {
        hyperlink = 'https://' + hyperlink; // Ensure it has https://
      }
      return `<a href="${hyperlink}" target="_blank" style="color: black; text-decoration: underline;">${url}</a>`;
    });

    // Sanitize and return safe HTML
    return this.sanitizer.bypassSecurityTrustHtml(formattedText);
  }
}
